import * as React from 'react'
import { TextField, Typography, MenuItem, StandardTextFieldProps, withStyles } from '@material-ui/core'

interface NationalCodeSelectProps extends StandardTextFieldProps {

}



const NationalCodeSelect = (props: NationalCodeSelectProps) => {

    return <TextField InputProps={{ disableUnderline: true }} variant="standard" select SelectProps={{ renderValue: (value: unknown) => <Typography>+{value as string}</Typography> }} style={{ width: '90px', height: '28px' }} {...props}>
        <MenuItem value="86">中国 +86</MenuItem>
        <MenuItem value="1">美国/加拿大 +1</MenuItem>
        <MenuItem value="7">俄罗斯 +7</MenuItem>
        <MenuItem value="20">埃及 +20</MenuItem>
        <MenuItem value="27">南非 +27</MenuItem>
        <MenuItem value="234">尼日利亚 +234</MenuItem>
        <MenuItem value="31">荷兰 +31</MenuItem>
        <MenuItem value="33">法国 +33</MenuItem>
        <MenuItem value="34">西班牙 +34</MenuItem>
        <MenuItem value="39">意大利 +39</MenuItem>
        <MenuItem value="358">芬兰 +358</MenuItem>
        <MenuItem value="41">瑞士 +41</MenuItem>
        <MenuItem value="44">英国 +44</MenuItem>
        <MenuItem value="45">丹麦 +45</MenuItem>
        <MenuItem value="46">瑞典 +46</MenuItem>
        <MenuItem value="47">挪威 +47</MenuItem>
        <MenuItem value="49">德国 +49</MenuItem>
        <MenuItem value="51">秘鲁 +51</MenuItem>
        <MenuItem value="52">墨西哥 +52</MenuItem>
        <MenuItem value="55">巴西 +55</MenuItem>
        <MenuItem value="58">委内瑞拉 +58</MenuItem>
        <MenuItem value="60">马来西亚 +60</MenuItem>
        <MenuItem value="61">澳大利亚 +61</MenuItem>
        <MenuItem value="62">印度尼西亚 +62</MenuItem>
        <MenuItem value="63">菲律宾 +63</MenuItem>
        <MenuItem value="64">新西兰 +64</MenuItem>
        <MenuItem value="65">新加坡 +65</MenuItem>
        <MenuItem value="66">泰国 +66</MenuItem>
        <MenuItem value="81">日本 +81</MenuItem>
        <MenuItem value="82">韩国 +82</MenuItem>
        <MenuItem value="84">越南 +84</MenuItem>
        <MenuItem value="852">中国香港 +852</MenuItem>
        <MenuItem value="853">中国澳门 +853</MenuItem>
        <MenuItem value="886">中国台湾 +886</MenuItem>
        <MenuItem value="855">柬埔寨 +855</MenuItem>
        <MenuItem value="880">孟加拉国 +880</MenuItem>
        <MenuItem value="90">土耳其 +90</MenuItem>
        <MenuItem value="91">印度 +91</MenuItem>
        <MenuItem value="92">巴基斯坦 +92</MenuItem>
        <MenuItem value="95">缅甸 +95</MenuItem>
        <MenuItem value="966">沙特阿拉伯 +966</MenuItem>
        <MenuItem value="972">以色列 +972</MenuItem>
    </TextField>
}

export default NationalCodeSelect